(function() {
    jQuery(document).ready(function () {
        window.avatarMenu = new cAvatar(".c-avatar-container");
        window.exploreButton = cExploreButton.init('.c-explore-button-container');
        window.mobileLeftMenu = new MobileLeftMenu(".c-mobile-left-menu");
        tmExploreMenuLoader.init();
        window.searchBoxDesktop = new cSearchBox(".s-header-search-wrapper .c-search-container");
        window.searchBoxMobile = new cSearchBox(".s-search-container-mobile .c-search-container");

        document.documentElement.style.setProperty('--scrollbar-width', `${getScrollbarWidth()}px`);

        if ( $(".s-search-container-mobile:not(.s-mobile-search-bar-hidden):visible").length > 0 ){
            $("body").addClass("has-search-mobile");
        }

        $(".c-close-header-section button").on("click", function(){
            $("body").removeClass("body-no-scroll");
            $("html").removeClass("html-modal-open");
        });

        $(".js-scrolls-widget-mobile").on("click", function(){
            if ( lastWindowState === 'small' && $("#v2BookingWidgetContainer").length ){
                $("html, body").animate({
                    scrollTop: ($("#v2BookingWidgetContainer").offset().top - 1 )
                }, 500);
            }
        });

        if ( $(".c-admin-logged-in-grid").length > 0 ){
            $(document).off("click", ".product-list .product-card:not(.carousel-product-card)");
            $(document).on("click", ".product-card.c-admin-logged-in-grid .product-card-body-top h3", function(e){
                e.preventDefault();
                const $h3 = $(this);

                if ( !$h3.find(".c-copy-admin-grid-product-title") ){
                    return true;
                }

                const $icon = $h3.find(".c-copy-admin-grid-product-title i");

                if ($icon.hasClass('fa-solid')) {
                    return;
                }            
            
                navigator.clipboard.writeText(
                    `Product: ` + $h3.text().trim() + ' [Dynamic] ' + '(' + $h3.find("a").data("tm-id") + ')'
                ).then(() => {

                    $icon.removeClass('fa-regular').addClass('fa-solid');
                    $icon.parent().append("<span>Copied!</span>");

                    setTimeout(function() {
                        $icon.removeClass('fa-solid').addClass('fa-regular');
                        $icon.parent().find('span').fadeOut(500, function() {
                            $(this).remove();
                        });
                    }, 500);                

                },() => {
                    /* Rejected - text failed to copy to the clipboard */
                });;                     
                
            });
        }

        $(document).on('focus', '.c-input-control input, .c-textarea-control textarea', function() {
            $(this).parents('.c-common-control').addClass('focused');
        });

        $(document).on('blur', '.c-input-control input, .c-textarea-control textarea', function() {
            $(this).parents('.c-common-control').removeClass('focused');
        });

        $(document).on('keyup change', '.c-input-control input, .c-textarea-control textarea', function() {
            if ($(this).val().length === 0) {
                $(this).parents('.c-common-control').addClass('empty');
            } else {
                $(this).parents('.c-common-control').removeClass('empty');
            }
        });

        if ( $("body.single-activity").length > 0 ) {
            const faqSummary = $('.faq-summary-answer');
            if ( $(faqSummary).length ){
                const faqSummaryAnswerText = $(faqSummary).find(".faq-summary-answer-text");
                const faqSummaryTextReadMore = $(faqSummary).find("a.c-mobile-only");
                const lineHeight = $(faqSummaryAnswerText).css("line-height").replace('px', '');
                const totalLines = $(faqSummaryAnswerText)[0].scrollHeight / lineHeight;
                const maxLines = $(faqSummaryAnswerText).data("max-lines-read-more-button") || 7;

                if (  totalLines > maxLines && $(window).width() > 1024) {
                    faqSummaryTextReadMore.removeClass('c-mobile-only');
                }
            }

            if ( $(".media-gallery").length > 0 ){
                window.activityDetailMainSlider = new cSlider(".media-gallery");
            }

            if ( $(".widget-area").length > 0 ){
                window.stickySidebar = new StickySidebar('.widget-area', {
                    topSpacing: 80,
                    bottomSpacing: 17,
                    containerSelector: '.element-container',
                    innerWrapperSelector: '.inner-wrapper-sticky',
                    minWidth: 1024,
                });
            }

            if ( $("#collapse-traveler-photos").length > 0 ){
                // delegated: the thumbnails arrive by AJAX (custom.js loadProductReviewPhotos())
                $("#collapse-traveler-photos").on("click", ".traveller__image__container", function( e ){
                    if ( typeof tmPhotoGallery !== 'undefined' && tmPhotoGallery !== null ){
                        tmPhotoGallery.showPhotoGalleryModal( 'traveler-photos', $(this).data('id') );
                    }
                });
            }

            if ( $(".c-traveler__slider").length > 0 && typeof $(".c-traveler__slider").comparisonTableSlickSlider === 'function' ){
                $(".c-traveler__slider").comparisonTableSlickSlider();
            }
        }

        if ( $(".c-hightlights-main-wrapper").length > 0 && typeof $(".c-hightlights-main-wrapper").highlightCardsSlickSlider === 'function' ){
            $(".c-hightlights-main-wrapper .c-scroll-content-pane").highlightCardsSlickSlider();
        }            


        if ( $('ul[data-total-items-ul]').length > 0 ){
            $('ul[data-total-items-ul]').each(function () {
                const $ul = $(this);
                const totalVisible = parseInt($ul.data('total-items-ul'), 10);
                const $items = $ul.find('li');

                if ($items.length > totalVisible) {
                    // Hide extra items
                    $items.slice(totalVisible).addClass('c-hidden');

                    // Create "See more" link
                    const hiddenCount = $items.length - totalVisible;
                    const $moreLink = $(`<a href="#" class="see-more-button no-color"><span>See ${hiddenCount} more</span>`);

                    $moreLink.insertAfter($ul);

                    // Handle click
                    $moreLink.on('click', function (e) {
                        e.preventDefault();
                        $ul.find('.c-hidden').removeClass('c-hidden');
                        $(this).remove();
                    });
                }
            });
        }

        $(".c-icon-bottom-values span[data-modal-target]").on("click", function (e) {
            e.stopPropagation();
        })

        // a tabbed modal's tabs (components/tabbed-modal: the Language / Currency popup, the shore-excursion route page's
        // Route / Ship popup): a tab shows its panel, #<tabs id>-tab-N inside .<tabs id>-tab
        $(".c-modal-header-wrapper > .c-tabs[id]").each(function () {
            var tabsId = this.id;
            if ( $("." + tabsId + "-tab").length === 0 ){
                return;
            }
            $(this).find(".c-tabs-item").on("click", function () {
                $(this).siblings(".c-tabs-item.c-tabs-item-active").removeClass("c-tabs-item-active");
                $(this).addClass("c-tabs-item-active");

                tab_id = '#' + tabsId + '-' + $(this).attr("data-tab-item-key");
                $("." + tabsId + "-tab .c-tab-navigation-content").addClass("c-hidden");
                $(tab_id).removeClass("c-hidden");
            });
        });

        $(document).on("click", ".suppress-activity-item a, .admin-links a", function (e) {
            e.stopPropagation();
        })

        $(document).on("click", ".tag-more-labels", function (e) {
            e.stopPropagation();
            $(this).siblings(".tag-label").removeClass("c-hidden");
            $(this).remove();
        })

    jQuery(document).on('viatorBookableItemSelectorChanged', function () {
        const $content = $('#viator-booking-wrapper-selected-info-description .read-more-content');

        if ( $content.text().length === 0 ){
            return;
        }

        const $wrapper = $content.parent();
        const lineHeight = parseFloat($content.css('line-height'));
        const lines = Math.round($content.parent().outerHeight() / lineHeight);
        $wrapper.find('.c-viator-read-more-link').remove();

        const shouldCollapse = lines > 4;

        $wrapper.toggleClass('show-only-2-lines', shouldCollapse);

        if (shouldCollapse) {
            $wrapper.append(`
                <a href="javascript:void(0)" class="c-viator-read-more-link">
                    <span>Read more</span>
                    <i class="far fa-chevron-down fa-xs" aria-hidden="true"></i>
                </a>
            `);
        }        
    });

        $(document).on("click", ".c-viator-read-more-link", function (e) {
            e.preventDefault();

            const $btn = $(this);
            const $wrapper = $("#viator-booking-wrapper-selected-info-description");

            const expanded = $btn.toggleClass("expanded").hasClass("expanded");

            $btn.find("span").text(expanded ? "Read less" : "Read more");

            $btn.find("i")
                .toggleClass("fa-chevron-up", expanded)
                .toggleClass("fa-chevron-down", !expanded);

            $wrapper.toggleClass("show-only-2-lines", !expanded);
        })

        // °F ⇄ °C on a weather pill (the old simple-weather markup; the Discover menu weather calls it from its card's switch,
        // mega-menu.js, with the pill and card as day). The first temperature decides the
        // direction; every .simple-weather__temp and [data-temp-f] in the pill flips and keeps its own suffix (°F/°C, a bare °, or none). data-temp-f, when present,
        // holds the exact °F so repeated flips never drift. instant = no fade (used right after the pill is inserted).
        window.tmFlipTemperature = function (day, instant) {
            const $temps = $(day).find(".simple-weather__temp, [data-temp-f]");
            if (!$temps.length) return;
            const toCelsius = $(day).find(".simple-weather__temp").first().text().trim().endsWith("F");
            const flip = function () {
                $temps.each(function () {
                    const $temp = $(this);
                    const text = $temp.text().trim();
                    const exactF = $temp.attr("data-temp-f");
                    const hasExactF = exactF !== undefined && exactF !== "" && !isNaN(Number(exactF));
                    const number = toCelsius && hasExactF ? Number(exactF) : parseFloat(text);
                    if (isNaN(number)) return;
                    const value = toCelsius
                        ? Math.round((number - 32) * 5 / 9)
                        : (hasExactF ? Number(exactF) : Math.round(number * 9 / 5 + 32));
                    let suffix = "";
                    if (text.endsWith("F") || text.endsWith("C")) {
                        suffix = toCelsius ? "°C" : "°F";
                    } else if (text.endsWith("°")) {
                        suffix = "°";
                    }
                    $temp.text(value + suffix);
                });
            };
            if (instant) {
                flip();
                return;
            }
            $temps.fadeOut(300).promise().done(function () {
                flip();
                $temps.fadeIn(300);
            });
        };
        $(document).on("click", ".simple-weather__day", function () {
            if ($(this).closest(".c-explore-weather").length) return; // the Discover menu pill opens its card instead
            window.tmFlipTemperature(this);
        });
    });
})();

function getScrollbarWidth() {
  // Temporary div create karo
  const scrollDiv = document.createElement("div");

  // CSS apply karo to force scrollbar
  scrollDiv.style.width = "100px";
  scrollDiv.style.height = "100px";
  scrollDiv.style.overflow = "scroll"; // force scrollbars
  scrollDiv.style.position = "absolute";
  scrollDiv.style.top = "-9999px"; // hide it

  document.body.appendChild(scrollDiv);

  // offsetWidth - clientWidth = scrollbar width
  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

  document.body.removeChild(scrollDiv);

  return scrollbarWidth;
}

const width = getScrollbarWidth();
